export const MD5Inspect = {
  SpeedMeter: 30001,
  Diesel: 30002
};
